import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { GetProviders } from '@tmhcc-ng-lib/startup';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OktaAuthGuard, OktaConfig2 } from '@tmhcc-ng-lib/framwork/okta-login';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { LoadingModule, LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { AlertModule } from '@tmhcc-ng-lib/framwork/alert';

import {
  ErrorHandlerService,
  ErrorInterceptor
} from '@tmhcc-ng-lib/framwork/services';
import {
  CustomPopupAlertModule,
  CustomPopupAlertService
} from '@tmhcc-ng-lib/framwork/custom-popup-alert';
import { FooterPageComponent } from '../../../../libs/artisan-edge/src/lib/footer/footer-page.component';
import { FormRendererModule } from '@tmhcc/form-renderer';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import {
  DialogConfig,
  DialogModule,
  DialogService
} from '@tmhcc-ng-lib/framwork/dialog';
import { ClickOutsideModule } from 'ng-click-outside';
import { PipesModule } from '@tmhcc-ng-lib/framwork/pipes';
import { AccordionModuleModule } from 'libs/artisan-edge/src/lib/accordion-menu/accordion-module.module';
import { GeneralInfoTabsModule } from '@tmhcc/artisan-edge';
import {
  BaseSiteCoreAPIMapper,
  GetCorePageDataService,
  FormBuildService
} from '@tmhcc-ng-lib/data-service';
import { UCMFormSitecoreMapperService } from 'libs/data-service/sitecore-data-mapper/ucm-form-site-core-mapper.service';
import {
  CoreInputValidationService,
  CoreInputsModule
} from '@tmhcc-ng-lib/framwork/core-inputs';
import { UCMSharedService } from 'libs/artisan-edge/src/lib/ucm-forms/ucm-shared.service';
import { UCMDialogComponent } from 'libs/artisan-edge/src/lib/ucm-forms/ucm-dialog/ucm-dialog.component';
import { SaveChangeGaurd } from '@tmhcc-ng-lib/global-services';
import { GeneralLiabilityUCMComponent } from 'libs/artisan-edge/src/lib/ucm-forms/general-liability/gl-ucm-forms.component';
import { PollutionLiabilityUCMComponent } from 'libs/artisan-edge/src/lib/ucm-forms/pollution-liability/pl-ucm-forms.component';
import { ProfessionalLiabilityUCMComponent } from 'libs/artisan-edge/src/lib/ucm-forms/professional-liability/pr-ucm-forms.component';
import { BuildersRiskUCMComponent } from 'libs/artisan-edge/src/lib/ucm-forms/builders-risk/br-ucm-forms.component';
import { ContractorsEquipmentUCMComponent } from 'libs/artisan-edge/src/lib/ucm-forms/contractors-equipment/ce-ucm-forms.component';
import { AddressChangeUCMComponent } from 'libs/artisan-edge/src/lib/ucm-forms/address-change/ac-ucm-forms.component';
import { ExposureChangeUCMComponent } from 'libs/artisan-edge/src/lib/ucm-forms/exposure-change/ec-ucm-forms.component';
import { ClassifiactionChangeUCMComponent } from 'libs/artisan-edge/src/lib/ucm-forms/classifiaction-change/cc-ucm-forms.component';

import { RefreshPageService } from 'libs/artisan-edge/src/lib/common-liability/nevigation/refresh-page.service';

/** Add following code to make sure form-renderer works in uat and prod env **/
import { CustomComponents } from '@tmhcc/form-renderer';
import { Formio } from 'formiojs';
import { ExcessLiabilityUCMComponent } from 'libs/artisan-edge/src/lib/ucm-forms/excess-liability/ex-ucm-forms.component';
Formio.use(CustomComponents);
/** **/

const config: OktaConfig2 = {
  baseUrl: environment.oktaWidgetConfig.baseUrl,
  issuer: environment.oktaWidgetConfig.issuer,
  redirectUri: environment.oktaWidgetConfig.redirectUri,
  clientId: environment.oktaWidgetConfig.clientId,
  scopes: environment.oktaWidgetConfig.scope,
  pkce: false,
  onSessionExpired: () => {}
};

@NgModule({
  declarations: [
    AppComponent,
    FooterPageComponent,
    GeneralLiabilityUCMComponent,
    PollutionLiabilityUCMComponent,
    ProfessionalLiabilityUCMComponent,
    BuildersRiskUCMComponent,
    ExcessLiabilityUCMComponent,
    ContractorsEquipmentUCMComponent,
    AddressChangeUCMComponent,
    ExposureChangeUCMComponent,
    ClassifiactionChangeUCMComponent,
    UCMDialogComponent
  ],
  imports: [
    GeneralInfoTabsModule,
    AccordionModuleModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CoreInputsModule,
    OktaAuthModule,
    LoadingModule,
    AlertModule,
    CustomPopupAlertModule,
    ClickOutsideModule,
    CustomPopupAlertModule,
    DialogModule,
    FormRendererModule
  ],

  providers: [
    OktaAuthGuard,
    LoaderService,
    DialogService,
    DialogConfig,
    Title,
    CoreInputValidationService,
    BaseSiteCoreAPIMapper,
    UCMFormSitecoreMapperService,
    GetCorePageDataService,
    CustomPopupAlertService,
    FormBuildService,
    UCMSharedService,
    SaveChangeGaurd,
    RefreshPageService,
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: OKTA_CONFIG, useValue: config },
    ...GetProviders('TMHCC ARTISANEDGE 2.0')
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
